const CUSTOMER_CONSTANT = {
  ENTERING: 0, //正在输入
  CANCEL_ENTERING: 2, //取消输入
  TITLE: "欢迎咨询客服" // 顶部客服名称下的欢迎
};
const WakeUpScene = {
  ordinary: 0, //普通场景
  Recharge: 1, //代客充值
  NotReceived: 2, //充值未到账
  Reflect: 3, //提现问题
  Game: 4, //游戏问题
  proxy: 5, //代理场景
  NoRechargeGate: 7 //无充值通道
};
const skillName = {
  NotReceived: "1", //充值未到账
  Reflect: "2", //提现问题
  Game: "3" //游戏问题
};
const invalidFlag = {
  //会话状态 1:有效会话   2：无效会话    3：排队中
  queueing: 3,
  Effective: 1,
  invalid: 2
};

export default {
  CUSTOMER_CONSTANT,
  WakeUpScene,
  invalidFlag,
  skillName
};
